import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-159e5fdd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "addr" }
const _hoisted_2 = { class: "mb_20 text-rt btn-block" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "valid-email"
}
const _hoisted_5 = { class: "action" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "abs"
}
const _hoisted_9 = ["onClick"]

import { ref, watch, computed } from 'vue'
import AddrForm from './AddrForm.vue'
import {
  getTakeAddr,
  updateTakeAddr,
  addTakeAddr,
  delTakeAddr,
  getClearAddr,
  updateClearAddr,
  addClearAddr,
  delClearAddr,
  setTakeAddr,
  setClearAddr
} from '@/apis/setup'
import { t } from '@/plugins/i18n'
import { ElMessage } from 'element-plus'
import setName from '@/util/useArea'
import { confirmDelAddr } from '@/util/useConfirm'
import { useRequest } from '@/util/useLoading'
import { isKO, isMultiStore } from '@/store'
import { useStore } from 'vuex'

enum Enum_country {
  'CN' = t('中国'),
  'KR' = t('韩国'),
}


export default /*#__PURE__*/_defineComponent({
  props: ['name'],
  setup(__props) {

const props = __props

const visible = ref(false)
const columns = [
  '出口国家',
  '姓名',
  '公司名',
  '会社编号',
  '联系电话',
  '邮箱',
  '国/地区',
  '都道府县',
  '市区町村',
  '详细地址',
  '邮编',
  '操作',
  '通关码'
]

// 国家枚举
const selected: any = ref([])
const data = ref([])
const item: any = ref(null)
const store = useStore()

const addApi = (data: any) =>
  props.name === 'take' ? addTakeAddr(data) : addClearAddr(data)
const delApi = (data: any) =>
  props.name === 'take'
    ? delTakeAddr({
      customerShopId: store.state.route.curShop,
      shopShippingAddressId: data.shopShippingAddressId
    })
    : delClearAddr({
      customerShopId: store.state.route.curShop,
      shopClearanceAddressId: data.shopClearanceAddressId
    })
const updateApi = (data: any) =>
  props.name === 'take' ? updateTakeAddr(data) : updateClearAddr(data)
const getApi = () => (props.name === 'take' ? getTakeAddr() : getClearAddr())
const setApi = (data: any) =>
  props.name === 'take' ? setTakeAddr(data) : setClearAddr(data)

const [loading, getData] = useRequest(() => {
  data.value = []
  return getApi().then((res) => {
    if (res.success) {
      res.data.forEach((v: any) => {
        setName(v)
        v.defaultAddress = !!v.defaultAddress
      })
      data.value = JSON.parse(JSON.stringify(res.data))
    }
  })
})
const _getData = () => {
  getData()
}

const add = () => {
  visible.value = true
  item.value = {
    isCreate: true
  }
}
const edit = (data: any) => {
  visible.value = true
  item.value = data
}
const update = (item: any) => {
  const { shopShippingAddressId, shopClearanceAddressId } = item
  item.defaultAddress = item.defaultAddress ? 1 : 0
  let api = addApi
  if (shopShippingAddressId || shopClearanceAddressId) {
    api = updateApi
  }
  if (!item.address) {
    item.address = item.addressEn
  }
  return api(item).then((res) => {
    if (res.success) {
      ElMessage.success(t(api === addApi ? t('添加成功') : t('修改成功')))
      getData()
    }
    return res.success
  })
}
const del = (item: any) => {
  confirmDelAddr(
    () => delApi(item).then(_getData),
    () => { }
  )
}

const handleSelect = (val: any) => {
  selected.value = val
}
const delLot = () => {
  confirmDelAddr(
    () => Promise.all(selected.value.map((v: any) => delApi(v))).then(_getData),
    () => { }
  )
}

const setDefault = (item: any) => {
  const { shopShippingAddressId, shopClearanceAddressId } = item
  setApi({ shopShippingAddressId, shopClearanceAddressId }).then(_getData)
}

getData()
watch(() => props.name, _getData)

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: add
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('添加新地址')), 1)
        ]),
        _: 1
      }),
      _withDirectives(_createVNode(_component_el_button, {
        type: "primary",
        onClick: delLot
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('批量删除')), 1)
        ]),
        _: 1
      }, 512), [
        [_vShow, selected.value.length]
      ])
    ]),
    _withDirectives(_createVNode(_component_el_table, {
      class: "mb_50",
      data: data.value,
      border: "",
      onSelectionChange: handleSelect,
      "table-layout": "auto"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "55",
          align: "center"
        }),
        (_unref(isMultiStore)() && __props.name === 'clear')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              prop: "exportCountry",
              label: _unref(t)(columns[0]),
              width: "120",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", null, _toDisplayString(Enum_country[row.exportCountry ?? 'CN']), 1)
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          prop: "receiveName",
          label: _unref(t)(columns[1]),
          width: "120",
          align: "center"
        }, null, 8, ["label"]),
        (__props.name === 'clear')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              prop: "companyName",
              label: _unref(t)(columns[2]),
              "min-width": "200",
              align: "center"
            }, null, 8, ["label"]))
          : _createCommentVNode("", true),
        (__props.name === 'clear')
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              prop: "companyCode",
              label: _unref(t)(columns[3]),
              width: "140",
              align: "center"
            }, null, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          prop: "phone",
          label: _unref(t)(columns[4]),
          width: "140",
          align: "center"
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "email",
          label: _unref(t)(columns[5]),
          width: "180",
          align: "center"
        }, {
          default: _withCtx(({ row }) => [
            (row.email)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(row.email), 1))
              : _createCommentVNode("", true),
            (__props.name === 'clear' && !row.email)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(t)('请填写邮箱')), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "countryName",
          label: _unref(t)(columns[6]),
          width: "120",
          align: "center"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.countryName || '日本'), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "areaName",
          label: _unref(t)(columns[7]),
          width: "120",
          align: "center"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.areaName || row.provinceName), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "cityName",
          label: _unref(t)(columns[8]),
          width: "120",
          align: "center"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.cityName), 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "address",
          label: _unref(t)(columns[9]),
          "min-width": "240",
          align: "center"
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "postalCode",
          label: _unref(t)(columns[10]),
          width: "120",
          align: "center"
        }, null, 8, ["label"]),
        (__props.name === 'clear' && _unref(isKO)())
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 3,
              prop: "clearanceCode",
              label: _unref(t)(columns[12]),
              width: "120",
              align: "center"
            }, null, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          fixed: "right",
          prop: "action",
          label: _unref(t)(columns[11]),
          width: "160",
          align: "center"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("label", {
                class: "btn",
                onClick: ($event: any) => (edit(row))
              }, _toDisplayString(_unref(t)('编辑')), 9, _hoisted_6),
              _createElementVNode("label", {
                class: "btn",
                onClick: ($event: any) => (del(row))
              }, _toDisplayString(_unref(t)('删除')), 9, _hoisted_7),
              (row.defaultAddress)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(t)('默认1')), 1))
                : (_openBlock(), _createElementBlock("label", {
                    key: 1,
                    class: "btn",
                    onClick: ($event: any) => (setDefault(row))
                  }, _toDisplayString(_unref(t)('设为默认')), 9, _hoisted_9))
            ])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["data"]), [
      [_directive_loading, _unref(loading)]
    ]),
    (item.value)
      ? (_openBlock(), _createBlock(AddrForm, {
          key: 0,
          visible: visible.value,
          "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
          data: item.value,
          "onUpdate:data": _cache[1] || (_cache[1] = ($event: any) => ((item).value = $event)),
          name: __props.name,
          update: update
        }, null, 8, ["visible", "data", "name"]))
      : _createCommentVNode("", true)
  ]))
}
}

})